export const BADGE_TIERS = [
  { key: "diamond", min: 51, emoji: "💎", labelKey: "badgeDiamond", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  { key: "gold", min: 31, emoji: "🥇", labelKey: "badgeGold", cls: "bg-yellow-50 text-yellow-700 border-yellow-300" },
  { key: "silver", min: 11, emoji: "🥈", labelKey: "badgeSilver", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  { key: "bronze", min: 10, emoji: "🥉", labelKey: "badgeBronze", cls: "bg-orange-50 text-orange-700 border-orange-200" },
];

export function getBadge(count) {
  return BADGE_TIERS.find((b) => count >= b.min) || null;
}

export function nextBadge(count) {
  const next = [...BADGE_TIERS].reverse().find((b) => count < b.min);
  return next ? { ...next, remaining: next.min - count } : null;
}
